module.exports = __webpack_public_path__ + "static/media/8.7cad4e66.mp3";